import React, { useEffect, useState } from "react";
import { startCapture, finishCapture } from "../../../actions";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import ROUTES from "../../AppRouter/routes";
import TrayViewer from "./TrayViewer";

const CaptureTray = ({ startCapture, selectedDevice, trayId, toolId }) => {
  const history = useHistory();
  const [sentCapture, setSentCapture] = useState(false);
  const [captureState, setCaptureState] = useState(true)

  useEffect(() => {
    const loadTray = async () => {
      if (!selectedDevice) {
        history.push(ROUTES.traysTab);
      }
      if (!sentCapture) {
        await startCapture(selectedDevice);
        setSentCapture(true);
        setCaptureState(true)
      }
    };
    loadTray();
  }, [history, selectedDevice, sentCapture, startCapture]);

  useEffect(() => {
    if (sentCapture) {
      return () => {
        finishCapture();
      };
    }
  }, [sentCapture]);

  const startAnotherCapture = () => {
    finishCapture(toolId, trayId)

    //need to wait until socket server to finish capture
    setTimeout(() => {
      setSentCapture(false)
      setCaptureState(false)
    }, 450)
  }

  return (<div style={{ height: "100%", width: "100%" }}>
    {captureState ? <TrayViewer startAnotherCapture={startAnotherCapture} /> : <div style={{ height: "100%", width: "100%", backgroundColor: "white" }} />}
  </div>)
}

export const mapStateToProps = (state) => {
  const { selectedDevice } = state.devices;
  if (!selectedDevice) return {};

  const {
    [selectedDevice]: { id: toolId, },
  } = state.devices;

  return {
    selectedDevice,
    trayId: state.capture?.tray?.['id'],
    toolId: toolId || ""
  };
};

export default connect(mapStateToProps, { startCapture, finishCapture })(
  CaptureTray
);
